import { render, staticRenderFns } from "./Trustpilot.vue?vue&type=template&id=178ebbde&lang=pug"
import script from "./Trustpilot.vue?vue&type=script&lang=ts"
export * from "./Trustpilot.vue?vue&type=script&lang=ts"
import style0 from "./Trustpilot.vue?vue&type=style&index=0&id=178ebbde&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports